//#region id generator
//generate unique id for local Data
export const GuidGenerator = () => {
  const cryptoObj = window.crypto || window.msCrypto; // for IE 11 support
  if (!cryptoObj) {
    console.error("Your browser doesn't support crypto API");
    return null;
  }

  const buffer = new Uint16Array(8);
  cryptoObj.getRandomValues(buffer);

  const S4 = function (num) {
    let ret = num.toString(16);
    while (ret.length < 4) {
      ret = "0" + ret;
    }
    return ret;
  };

  return (
    S4(buffer[0]) + S4(buffer[1]) + "-" +
    S4(buffer[2]) + "-" +
    S4(buffer[3]) + "-" +
    S4(buffer[4]) + "-" +
    S4(buffer[5]) + S4(buffer[6]) + S4(buffer[7])
  );
};
//#endregion id generator
